import Skeleton from 'react-loading-skeleton'
import styles from 'components/InterestCard/InterestCard.module.sass'

const InterestLoading = () => (
  <div className={styles.card}>
    <div style={{ minWidth: '100px' }}>
      <Skeleton height={75} />
    </div>
    <div style={{ width: '-webkit-fill-available' }}>
      <Skeleton count={3} />
    </div>
  </div>
)

export default InterestLoading
